module.exports = __webpack_public_path__ + "img/qrcode.455d216c.png";